export default {
  apiKey: 'AIzaSyBtOItzrHpg-wp5WLtU2-I-NTftA-K7fgs',
  authDomain: 'shestrong-app.firebaseapp.com',
  projectId: 'shestrong-app',
  storageBucket: 'shestrong-app.appspot.com',
  messagingSenderId: '531785102867',
  appId: '1:531785102867:web:b138b10d2068473c04f1e6',
  measurementId: 'G-BL4BWHWWVK',
};
